module.exports = "#define GLSLIFY 1\nuniform sampler2D tInput;\n\nvarying vec2 vUv0;\nvarying vec2 vUv1;\nvarying vec2 vUv2;\nvarying vec2 vUv3;\n\nvoid main() {\n\n\t// Sample top left texel.\n\tvec4 sum = texture2D(tInput, vUv0);\n\n\t// Sample top right texel.\n\tsum += texture2D(tInput, vUv1);\n\n\t// Sample bottom right texel.\n\tsum += texture2D(tInput, vUv2);\n\n\t// Sample bottom left texel.\n\tsum += texture2D(tInput, vUv3);\n\n\t// Compute the average.\n\tgl_FragColor = sum * 0.25;\n\n}"


//////////////////
// WEBPACK FOOTER
// ./three/shaders/blur_shader.frag
// module id = 359
// module chunks = 0